/* eslint-disable eqeqeq */
import React, { Component, Fragment } from "react";
import {
  Divider,
  IconButton,
  Tooltip,
  CircularProgress,
  Toolbar,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import R301GeneralPricingTableComponent from "./F301GeneralDiscountReportTableComponent";
import FilterIcon from "mdi-material-ui/FilterOutline";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import EditDeleteTableRecord from "../../../components/EditDeleteTableRecord/EditDeleteTableRecord";
import NavBar from "../../../components/NavBar/NavBar";
import { HttpRequest } from "../../../utils/httpRequests";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";

class F301GeneralDiscountReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showTableFilter: false,
      showSearchBar: false,

      Data: [],

      studentName: "",
      genderId: 0,
      degreeId: 0,
      applicationId: "",
      eventDate: null,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      isLoginMenu: false,
      isReload: true,
    };
  }

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      isOpenSnackbar: false,
    });
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  onClearFilters = () => {
    this.setState({
      studentName: "",
      genderId: 0,
      degreeId: 0,
      applicationId: "",
      eventDate: null,
    });
  };

  handleDateChange = (date) => {
    this.setState({
      eventDate: date,
    });
  };

  getData = async () => {
    this.setState({
      isLoading: true,
    });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C301CommonProductsDiscountViewV2`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        for (var i = 0; i < res.data.length; i++) {
          res.data[i].action = (
            <EditDeleteTableRecord
              isActive={res.data[i].isActive}
              recordId={res.data[i].id}
              DeleteData={this.DeleteData}
              primaryButtonDisabled={res.data[i].statusId == 3}
              handleChangeStatus={(recordId, isActive) =>
                this.handleChangeStatus(recordId, isActive)
              }
              onEditURL={`#/F301GeneralDiscountFormV4/${res.data[i].id}`}
            />
          );
        }
        this.setState({
          Data: res.data || [],
        });
        console.log(" res.DATA AFTER", res.data);
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

    this.setState({
      isLoading: false,
    });
  };

  handleChangeStatus = async (recordId, isActive) => {
    const data = new FormData();
    data.append("id", recordId);
    data.append("isActive", isActive);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C301CommonProductDiscountActiveStatusUpdate`,
      data,
      "authorize"
    );
    console.log(res);
    if (res.isSuccess) {
      this.handleSnackbar(true, "Status Changed", "success");
      window.location.reload();
      return "1";
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }

      return "0";
    }
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleToggleTableFilter = () => {
    this.setState({ showTableFilter: !this.state.showTableFilter });
  };

  handleToggleSearchBar = () => {
    this.setState({ showSearchBar: !this.state.showSearchBar });
  };

  componentDidMount() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.getData();
  }

  render() {
    const columns = [
      { name: "SRNo", title: "SR#" },

      { name: "priceLabel", title: "Label" },

      { name: "isActiveStr", title: "Active" },

      { name: "Category", title: "Categories" },

      {
        name: "effectiveFromStr",
        title: "Effective\xa0From",
        wordWrapEnabled: true,
      },
      {
        name: "effectiveToStr",
        title: "Effective\xa0To",
        wordWrapEnabled: true,
      },
      {
        name: "statusLabel",
        title: "Status",
        wordWrapEnabled: true,
        getCellValue: (row) => {
          return (
            <div
              style={{
                color: `${
                  row.statusId == 3
                    ? "darkred"
                    : row.statusId == 2
                    ? "#be4f00"
                    : "black"
                }`,
                overflowWrap: "break-word",
                wordBreak: "break-word" /* Fallback for older browsers */,
                whiteSpace: "normal",
              }}
            >
              {row.statusLabel}
            </div>
          );
        },
      },
      { name: "action", title: "Action" },
    ];

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <div
          style={{
            padding: 20,
          }}
        >
          <Toolbar>
            <NavBar isAuthorize title="Discount Pricing" />
          </Toolbar>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                color: "#1d5f98",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
              variant="h5"
            >
              <Tooltip title="Back">
                <IconButton onClick={() => window.history.back()}>
                  <ArrowBackIcon fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>
              General Discounts Report
            </Typography>
            <div style={{ float: "right" }}>
              <Tooltip title="Table Filter">
                <IconButton
                  style={{ marginLeft: "-10px" }}
                  onClick={this.handleToggleTableFilter}
                >
                  <FilterIcon fontSize="default" color="primary" />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <Divider
            style={{
              backgroundColor: "rgb(58, 127, 187)",
              opacity: "0.3",
            }}
          />

          {this.state.isLoading ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: 50,
              }}
            >
              <CircularProgress
                size={50}
                style={{ color: "rgb(29, 95, 152)", fontWeight: 600 }}
              />
            </div>
          ) : (
            <>
              {this.state.Data && (
                <R301GeneralPricingTableComponent
                  data={this.state.Data}
                  columns={columns}
                  showFilter={this.state.showTableFilter}
                />
              )}
            </>
          )}
          <CustomizedSnackbar
            isOpen={this.state.isOpenSnackbar}
            message={this.state.snackbarMessage}
            severity={this.state.snackbarSeverity}
            handleCloseSnackbar={() => this.handleCloseSnackbar()}
          />
        </div>
      </Fragment>
    );
  }
}
export default F301GeneralDiscountReport;
